'use strict'

const config = {
  timeOutMs: 60000,
  popUpUrl: 'https://bridge.dcentwallet.com/v2'
}

module.exports = {
  config
}
